import React, { memo } from 'react';
import { useBlockFromPage } from '../../../stores/InterfaceStore';
import type { WithBlockStateProps } from '../types';
import type { BlockRendererWrapperProps } from '../../RegistryProvider/types';
import { isEmptyBlock } from '../../../utils/block';
import { ErrorBoundary } from '../../../../components/ErrorBoundary';
import { dummyComponentNode } from '../../../../consts/component';

export const withBlockPage = (WrappedComponent: React.ComponentType<WithBlockStateProps>) => {
  function WithBlockPage(props: BlockRendererWrapperProps) {
    const { blockId, ...rest } = props;
    const block = useBlockFromPage({ blockId });

    if (isEmptyBlock(blockId)) {
      return null;
    }

    if (block) {
      return (
        <ErrorBoundary fallback={dummyComponentNode}>
          <WrappedComponent {...rest} block={block} />
        </ErrorBoundary>
      );
    }

    console.error(`Unexpected scenario! Block with id ${blockId} not found.`);
    return null;
  }

  return memo(WithBlockPage);
};
